module.exports = __webpack_public_path__ + "static/media/ios-cart.b4a30bdd.svg";